export default {
      id: "oc-menu-multicloud-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-multicloud",
      toString: function () {
        return this.url;
      }
    }